import { render, staticRenderFns } from "./HtmlViewer.vue?vue&type=template&id=52b68be5"
import script from "./HtmlViewer.vue?vue&type=script&lang=js"
export * from "./HtmlViewer.vue?vue&type=script&lang=js"
import style0 from "./HtmlViewer.vue?vue&type=style&index=0&id=52b68be5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports